import { Box, Tooltip, SxProps, Theme, Link } from "@mui/material";
import LocalTime from "./LocalTime/LocalTime";
export type SxWithMandatoryWidth = SxProps<Theme> & { width: number | string };

export interface GenericTableRowTooltipProps {
	value?: any;
	kind?: "text" | "link" | "datetime";
	link?: string;
	data?: string;
	sx?: SxWithMandatoryWidth;
}

export function GenericTableRowTooltip(props: GenericTableRowTooltipProps) {
	const { value, link, sx, data } = props;
	const kind = props.kind ?? "text";
	
	if (kind === "datetime") {
		return (<LocalTime utcDate={data}>
			<Box component={"div"} sx={sx ?? {}}>
				{value}
			</Box>
		</LocalTime>);
	}
	return (
		<Tooltip title={value}>
			<Box>
				{kind === "link" && (
					<Link sx={sx ?? {}} rel="icon" href={link}>
						{value}
					</Link>
				)}
				{kind === "text" && (
					<Box component={"div"} sx={sx ?? {}}>
						{value}
					</Box>
				)}
			</Box>
		</Tooltip>
	);
}
